import { PerformanceUpsellParagraph } from "./PerformanceUpsellParagraph";

import { useMemo } from "react";
import { useCurrentDate } from "src/components/time/time";

import type { QueryResultJob } from "src/utils/results/types";

interface Props {
  executionStartedAt: Exclude<QueryResultJob["created_at"], undefined>;
}

export function PerformanceUpsellParagraphIfLongExecutionTime(props: Props) {
  const now = useCurrentDate();

  const start = useMemo(
    () => new Date(props.executionStartedAt),
    [props.executionStartedAt]
  );

  const secondsElapsed = Math.floor((now - start.valueOf()) / 1000);

  if (secondsElapsed < 60) {
    return null;
  }

  return <PerformanceUpsellParagraph />;
}
